import { User } from "firebase/auth"
import { createContext } from "react"

const AuthContext = createContext<(User & {xpId?: string}) | null | undefined>(undefined)

export default AuthContext
